module.exports = __webpack_public_path__ + "static/media/tools-pin-close.448532ea.svg";